import _Handlebars2 from '../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js';
import { View, loc, createButton, createCallout } from '../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js';
import '../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js';
import '../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js';
import '../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js';
import oktaUnderscore from '../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
import '../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js';
import '../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js';
import '../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js';
import '../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js';
import Enums from '../../../util/Enums.js';
import { ChromeLNADeniedError } from '../../../util/Errors.js';
import Util from '../../../util/Util.js';
import { IDENTIFIER_FLOW, FASTPASS_FALLBACK_SPINNER_TIMEOUT, OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE, OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP, OV_UV_ENABLE_BIOMETRICS_FASTPASS_WINDOWS, REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON, LOOPBACK_RESPONSE_STATUS_CODE } from './Constants.js';
import fn from '../../../util/BrowserFeatures.js';

function appendLoginHint(deviceChallengeUrl, loginHint) {
  if (deviceChallengeUrl && loginHint) {
    deviceChallengeUrl += '&login_hint=' + loginHint;
  }
  return deviceChallengeUrl;
}
const LNAErrorViewContent = View.extend({
  template: _Handlebars2.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "chrome.lna.error.description.intro"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 65
          }
        }
      })) + "<ol class=\"chrome-lna-error-steps\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "chrome.lna.error.description.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 104
          },
          "end": {
            "line": 1,
            "column": 169
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "chrome.lna.error.description.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 178
          },
          "end": {
            "line": 1,
            "column": 243
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "chrome.lna.error.description.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 252
          },
          "end": {
            "line": 1,
            "column": 317
          }
        }
      })) + "</li></ol>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<a href='#' target='_blank' rel='noopener noreferrer' class='chrome-lna-help-link'>$1</a>",
          "bundle": "login",
          "code": "chrome.lna.error.description.more.information"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 327
          },
          "end": {
            "line": 1,
            "column": 498
          }
        }
      }));
    },
    "useData": true
  }),
  getTemplateData: function () {
    this.chromeLNAHelpLink = this.options.chromeLNAHelpLink;
  },
  render: function () {
    View.prototype.render.apply(this, arguments);
    if (this.chromeLNAHelpLink) {
      this.$el.find('.chrome-lna-help-link').attr('href', this.chromeLNAHelpLink);
    }
  }
});
function addLNAErrorView(view, chromeLNAHelpLink) {
  view.add(createCallout({
    title: loc('chrome.lna.error.title', 'login'),
    content: new LNAErrorViewContent({
      chromeLNAHelpLink: chromeLNAHelpLink
    }),
    type: 'error'
  }));
}
function addLoopbackView(view, deviceChallenge) {
  view.add(View.extend({
    className: 'loopback-content',
    template: _Handlebars2.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        return "<div class=\"spinner\"></div>";
      },
      "useData": true
    })
  }));
  view.doLoopback(deviceChallenge);
}
function updateChromeLNATitle(view, newTitle) {
  view.title = newTitle;
  if (view.$ && view.$('.okta-form-title').length) {
    view.$('.okta-form-title').text(newTitle);
  }
}
function handlePermissionState(view, currPermissionState, deviceChallenge) {
  view.removeChildren();
  switch (currPermissionState) {
    case 'prompt':
    case 'granted':
      updateChromeLNATitle(view, loc('deviceTrust.sso.redirectText', 'login'));
      addLoopbackView(view, deviceChallenge);
      break;
    case 'denied':
      {
        var _view$options, _view$options$appStat;
        // If there is no previous form name, it is a silent probe triggered by the registered condition
        const isRegisteredConditionSilentProbe = ((_view$options = view.options) === null || _view$options === void 0 ? void 0 : (_view$options$appStat = _view$options.appState) === null || _view$options$appStat === void 0 ? void 0 : _view$options$appStat.get('previousFormName')) === undefined;
        if (isRegisteredConditionSilentProbe) {
          updateChromeLNATitle(view, loc('deviceTrust.sso.redirectText', 'login'));
          addLoopbackView(view, deviceChallenge);
        } else {
          var _deviceChallenge$chro;
          updateChromeLNATitle(view, loc('chrome.lna.fastpass.requires.permission.title', 'login'));
          addLNAErrorView(view, (_deviceChallenge$chro = deviceChallenge.chromeLocalNetworkAccessDetails) === null || _deviceChallenge$chro === void 0 ? void 0 : _deviceChallenge$chro.chromeLNAHelpLink);
          // Log error for Sentry monitoring
          throw new ChromeLNADeniedError('Chrome Local Network Access permission was denied for FastPass.');
        }
        break;
      }
    default:
      updateChromeLNATitle(view, loc('deviceTrust.sso.redirectText', 'login'));
      addLoopbackView(view, deviceChallenge);
      break;
  }
}
function doChallenge(view, fromView) {
  var _view$options2, _view$options2$settin;
  const deviceChallenge = view.getDeviceChallengePayload();
  const {
    chromeLocalNetworkAccessDetails: chromeLocalNetworkAccessDetails
  } = deviceChallenge || {};
  const loginHint = (_view$options2 = view.options) === null || _view$options2 === void 0 ? void 0 : (_view$options2$settin = _view$options2.settings) === null || _view$options2$settin === void 0 ? void 0 : _view$options2$settin.get('identifier');
  const HIDE_CLASS = 'hide';
  switch (deviceChallenge.challengeMethod) {
    case Enums.LOOPBACK_CHALLENGE:
      {
        view.title = loc('deviceTrust.sso.redirectText', 'login');
        if (chromeLocalNetworkAccessDetails) {
          fn.getChromeLNAPermissionState(currPermissionState => handlePermissionState(view, currPermissionState, deviceChallenge));
        } else {
          addLoopbackView(view, deviceChallenge);
        }
        break;
      }
    case Enums.CUSTOM_URI_CHALLENGE:
      view.title = loc('customUri.title', 'login');
      view.add(View.extend({
        className: 'skinny-content',
        template: _Handlebars2.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.prompt"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 3
                },
                "end": {
                  "line": 1,
                  "column": 67
                }
              }
            })) + "</p>";
          },
          "useData": true
        })
      }));
      view.add(createButton({
        className: 'ul-button button button-wide button-primary',
        title: loc('oktaVerify.open.button', 'login'),
        id: 'launch-ov',
        click: () => {
          view.doCustomURI();
        }
      }));
      view.add(View.extend({
        className: 'skinny-content',
        template: _Handlebars2.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }
                return undefined;
              };
            return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.download.title"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 3
                },
                "end": {
                  "line": 1,
                  "column": 75
                }
              }
            })) + "</p><p><a href=\"" + alias3((helper = (helper = lookupProperty(helpers, "downloadOVLink") || (depth0 != null ? lookupProperty(depth0, "downloadOVLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
              "name": "downloadOVLink",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 91
                },
                "end": {
                  "line": 1,
                  "column": 109
                }
              }
            }) : helper)) + "\" target=\"_blank\" id=\"download-ov\" class=\"link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.download.linkText"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 157
                },
                "end": {
                  "line": 1,
                  "column": 232
                }
              }
            })) + "</a></p>";
          },
          "useData": true
        }),
        getTemplateData: function () {
          return {
            downloadOVLink: deviceChallenge.downloadHref
          };
        }
      }));
      view.customURI = appendLoginHint(deviceChallenge.href, loginHint);
      view.doCustomURI();
      break;
    case Enums.UNIVERSAL_LINK_CHALLENGE:
      view.title = loc('universalLink.title', 'login');
      view.add(View.extend({
        className: 'universal-link-content',
        template: _Handlebars2.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return "<div class=\"spinner\"></div>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "universalLink.content"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 27
                },
                "end": {
                  "line": 1,
                  "column": 79
                }
              }
            }));
          },
          "useData": true
        })
      }));
      view.add(createButton({
        className: 'ul-button button button-wide button-primary',
        title: loc('oktaVerify.open.button', 'login'),
        click: () => {
          // only window.location.href can open universal link in iOS/MacOS
          // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
          let deviceChallengeUrl = appendLoginHint(deviceChallenge.href, loginHint);
          Util.redirect(deviceChallengeUrl);
        }
      }));
      break;
    case Enums.APP_LINK_CHALLENGE:
      view.title = loc('appLink.title', 'login');
      view.add(View.extend({
        className: 'app-link-content',
        template: _Handlebars2.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = "function",
              alias4 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }
                return undefined;
              };
            return "<div class=\"spinner " + alias4((helper = (helper = lookupProperty(helpers, "hideClass") || (depth0 != null ? lookupProperty(depth0, "hideClass") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
              "name": "hideClass",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 20
                },
                "end": {
                  "line": 1,
                  "column": 33
                }
              }
            }) : helper)) + "\"></div><div class=\"appLinkContent " + alias4((helper = (helper = lookupProperty(helpers, "hideClass") || (depth0 != null ? lookupProperty(depth0, "hideClass") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
              "name": "hideClass",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 68
                },
                "end": {
                  "line": 1,
                  "column": 81
                }
              }
            }) : helper)) + "\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "appLink.content"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 83
                },
                "end": {
                  "line": 1,
                  "column": 129
                }
              }
            })) + "</div>";
          },
          "useData": true
        }),
        getTemplateData: function () {
          return {
            hideClass: HIDE_CLASS
          };
        },
        postRender: function () {
          if (fromView === IDENTIFIER_FLOW) {
            this.$('.spinner').removeClass(HIDE_CLASS);
            setTimeout(oktaUnderscore.bind(() => {
              const data = {
                label: loc('goback', 'login')
              };
              this.options.appState.trigger('updateFooterLink', data);
              this.$('.spinner').addClass(HIDE_CLASS);
              this.$('.appLinkContent').removeClass(HIDE_CLASS);
            }, this), FASTPASS_FALLBACK_SPINNER_TIMEOUT);
          } else {
            this.$('.appLinkContent').removeClass(HIDE_CLASS);
          }
        }
      }));
      view.add(createButton({
        className: `${HIDE_CLASS} al-button button button-wide button-primary`,
        title: loc('oktaVerify.open.button', 'login'),
        click: () => {
          // only window.location.href can open app link in Android
          // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
          let deviceChallengeUrl = appendLoginHint(deviceChallenge.href, loginHint);
          Util.redirect(deviceChallengeUrl, window, true);
        },
        postRender: function () {
          if (fromView === IDENTIFIER_FLOW) {
            setTimeout(oktaUnderscore.bind(() => {
              this.$el.removeClass(HIDE_CLASS);
            }, this), FASTPASS_FALLBACK_SPINNER_TIMEOUT);
          } else {
            this.$el.removeClass(HIDE_CLASS);
          }
        }
      }));
      break;
    case Enums.CHROME_DTC:
      // reusing the existing message for Chrome DTC
      view.title = loc('deviceTrust.sso.redirectText', 'login');
      view.add(View.extend({
        className: 'chrome-dtc-content',
        template: _Handlebars2.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            return "<div class=\"spinner\"></div>";
          },
          "useData": true
        })
      }));
      view.doChromeDTC(deviceChallenge);
      break;
  }
}
function cancelPollingWithParams(appState, pollingCancelAction, cancelReason, statusCode, showFormErrors) {
  const actionParams = {};
  actionParams[REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON] = cancelReason;
  actionParams[LOOPBACK_RESPONSE_STATUS_CODE] = statusCode;
  appState.trigger('invokeAction', pollingCancelAction, actionParams, showFormErrors);
}
function getBiometricsErrorOptions(error, isMessageObj) {
  let errorSummaryKeys;
  if (isMessageObj) {
    var _error$value$;
    errorSummaryKeys = Object.values(error === null || error === void 0 ? void 0 : (_error$value$ = error.value[0]) === null || _error$value$ === void 0 ? void 0 : _error$value$.i18n);
  } else {
    var _error$responseJSON;
    errorSummaryKeys = error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorSummaryKeys;
  }
  const isBiometricsRequiredMobile = errorSummaryKeys && errorSummaryKeys.includes(OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE);
  const isBiometricsRequiredDesktop = errorSummaryKeys && errorSummaryKeys.includes(OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP);
  const isBiometricsRequiredWindows = errorSummaryKeys && errorSummaryKeys.includes(OV_UV_ENABLE_BIOMETRICS_FASTPASS_WINDOWS);
  let options = [];
  if (!isBiometricsRequiredMobile && !isBiometricsRequiredDesktop && !isBiometricsRequiredWindows) {
    return options;
  }
  if (isBiometricsRequiredWindows) {
    options = {
      type: 'error',
      className: 'okta-verify-uv-callout-content',
      title: loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.title', 'login'),
      subtitle: loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.description', 'login'),
      bullets: [loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point1', 'login'), loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point2', 'login')]
    };
    return options;
  }
  const bulletPoints = [loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1', 'login'), loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2', 'login'), loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3', 'login')];

  // Add an additional bullet point for desktop devices
  if (isBiometricsRequiredDesktop) {
    bulletPoints.push(loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4', 'login'));
  }
  options = {
    type: 'error',
    className: 'okta-verify-uv-callout-content',
    title: loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title', 'login'),
    subtitle: loc('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description', 'login'),
    bullets: bulletPoints
  };
  return options;
}
function createInvisibleIFrame(iFrameId, iFrameSrc) {
  const iFrameView = View.extend({
    tagName: 'iframe',
    id: iFrameId,
    attributes: {
      src: iFrameSrc
    },
    initialize: function () {
      this.el.style.display = 'none';
    }
  });
  return iFrameView;
}

export { appendLoginHint, cancelPollingWithParams, createInvisibleIFrame, doChallenge, getBiometricsErrorOptions };
//# sourceMappingURL=ChallengeViewUtil.js.map
